import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Endpoints } from '../../apis';
import { getErrorMessage } from '@xver/utils/error';

interface Vars {
    id: number;
    position: number;
}

export function useDeleteFirewallRuleMutate() {
    const { t } = useTranslation('notifications');
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, position }: Vars) =>
            Endpoints.v1.Firewalls.VMRules.deleteRule(id, position),
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({
                queryKey: ['api.v1.firewalls.vm-rules', variables.id],
            });
            notifications.show({
                title: t('firewall.ruleDeletedTitle'),
                message: t('firewall.ruleDeletedMessage'),
                icon: <IconCheck size={32} color={'#00ff00'} />,
            });
        },
        onError: (error: any) => {
            notifications.show({
                title: t('firewall.ruleDeleteFailedTitle'),
                message: getErrorMessage(error),
                icon: <IconExclamationCircle size={32} color={'#eb5757'} />,
            });
        },
    });
}
